module.exports = __webpack_public_path__ + "img/dwg.f2391ec0.svg";